module.exports = __webpack_public_path__ + "media/src/images/top_covers/2ajisai-af024bb85cdb5c93ca4d7ca3451d6d04.png";